import React, { type FC } from 'react';
import { useTranslation } from '@/app/components/translations/Translation';
import { usePageWrapperData } from '@/app/common/pageWrapperProvider.tsx';
import { useSearchDealsPageData } from '@/app/components/search/searchDealsPageProvider.tsx';
import { useCommonClient } from '@/app/common/commonClientProvider.tsx';
import { ViewMode } from '@/app/common/viewModeUtils.ts';
import { ViewModeButton, ViewModeContainer } from './styled';
import { noop } from '../../../../Utilities';

type ViewModeToggleProps = {
  viewMode: ViewMode;
  isWaiting: boolean;
  sustainabilityEnabled?: boolean;
};

const ViewModeToggle: FC<ViewModeToggleProps> = ({ viewMode, isWaiting, sustainabilityEnabled }) => {
  const {
    localization: { imageBasePath },
  } = usePageWrapperData();
  const { externalHeaderEnabled } = useCommonClient();
  const { handleViewModeSwitch } = useSearchDealsPageData();
  const viewMap = viewMode === ViewMode.LIST;
  const viewMapBackgroundUrl = `${imageBasePath}map-large-bg.svg`;
  const viewListBackgroundUrl = `${imageBasePath}map-bg.svg`;
  const { t } = useTranslation();

  return (
    <ViewModeContainer
      bg={viewMap ? viewMapBackgroundUrl : viewListBackgroundUrl}
      viewMode={viewMode}
      id="view-mode"
      sustainabilityEnabled={sustainabilityEnabled}
      externalHeaderEnabled={externalHeaderEnabled}
    >
      <ViewModeButton onClick={isWaiting ? noop : handleViewModeSwitch} disabled={isWaiting} viewMode={viewMode}>
        {viewMap ? t('vacation.oss.map.view_map') : t('vacation.oss.map.view_list')}
      </ViewModeButton>
    </ViewModeContainer>
  );
};
export default ViewModeToggle;
